import { c as _c } from "react/compiler-runtime";
import MainComponent from 'modules/main/components/main';
import { MainLoco } from 'modules/main/constants/main-loco';
import { NextPage } from 'next';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
const Main: NextPage = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MainComponent />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const getServerSideProps = getBaseServerSideProps(MainLoco);
export default Main;